<form
    class="flex w-96 flex-col p-5"
    [formGroup]="form">
    <h1 class="mb-5 text-center text-xl">Create banner</h1>
    <mat-form-field>
        <mat-label>Provider</mat-label>
        <mat-select formControlName="provider">
            @for (keyValue of BannerProvider | appEnumKeyValue; track $index) {
                <mat-option [value]="keyValue.value">{{ keyValue.key }}</mat-option>
            }
        </mat-select>
    </mat-form-field>
    <mat-form-field>
        <mat-label>Allowed countries</mat-label>
        <mat-chip-grid
            #grid
            formControlName="allowedCountries">
            @for (country of allowedCountriesControl.value; track country) {
                <mat-chip-row (removed)="removeCountry(country)">
                    {{ country }}
                    <button matChipRemove>
                        <mat-icon>cancel</mat-icon>
                    </button>
                </mat-chip-row>
            }
        </mat-chip-grid>
        <input
            placeholder="Country code"
            [matChipInputFor]="grid"
            (matChipInputTokenEnd)="addCountry($event)" />
    </mat-form-field>
    <mat-checkbox
        color="primary"
        class="-ml-1 mb-2"
        formControlName="isActive">
        Active
    </mat-checkbox>
    <button
        mat-flat-button
        color="primary"
        [disabled]="form.invalid"
        (click)="close()">
        Submit
    </button>
</form>
